import React, { PropsWithChildren } from "react";
import styled from "styled-components";

import { accordionTransitionTiming } from "./Accordion";
import { AccordionContext } from "./context";

interface IFullControlAccordionProps extends PropsWithChildren {
  isOpen: boolean;
  onClick?: () => void;
}

/**
 * Same as ./Accordion.tsx, except the parent component controls the state
 * @trackcomponent
 * @supersededBy "@faire/web/slate/Accordion/Accordion#Accordion"
 */
export const FullControlAccordion: React.FC<IFullControlAccordionProps> = ({
  isOpen,
  children,
  onClick,
}) => (
  <AccordionContext.Provider value={isOpen}>
    <Wrapper onClick={onClick}>{children}</Wrapper>
  </AccordionContext.Provider>
);

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  min-height: fit-content;
  overflow: hidden;
  cursor: ${({ onClick }) => (onClick ? "pointer" : "unset")};
  ${accordionTransitionTiming}
`;
